<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="max-w-7xl mx-auto flex items-center justify-start">
        <h1 class="text-3xl font-bold text-gray-900 ml-0 md:ml-4 aarni-font">
            Lateral Entry/Migration</h1>
    </div>
</div>

<div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
        <aside class="w-full lg:w-1/4 space-y-4 lg:h-[950px] lg:overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Applying to ARNI</h2>
                    <div>
                        <a
                            href="/admissions/overview"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive('/admissions/overview'),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive('/admissions/overview')
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-y border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Overview</span>
                        </a>

                        <a
                            *ngFor="let link of [
            { href: '/admissions/campus-virtual-tour', label: 'Campus Virtual Tour' },
            { href: '/admissions/criteria', label: 'Admission Criteria' },
            { href: '/admissions/flow', label: 'Admission Flow' },
            { href: '/admissions/program-fee', label: 'Program Fees' },
            { href: '/admissions/hostel-fee', label: 'Accommodation & Hostel' },
            { href: '/admissions/transportation-fee', label: 'Transportation Services' },
            { href: '/admissions/scholarship', label: 'Scholarship Opportunities' },
            { href: '/admissions/innovative-idea-scholarship', label: 'Innovative Idea Grants' },
            { href: '/admissions/fee-structure-for-previous-year-students', label: 'Fee Structures for Previous Year Students' },
            { href: '/admissions/education-loan-assistance', label: 'Education Loan Support' },
            { href: '/admissions/how-to-apply', label: 'How to Apply' },
            { href: '/quick-links/contact-us', label: 'Counseling Services' },
            { href: '/admissions/payment-procedure', label: 'Payment Procedure' },
            { href: '/admissions/refund-policy', label: 'Refund Policy' },
            { href: '/admissions/avenues-for-success', label: 'Avenues for Success@ARNI' },
            { href: '/admissions/lateral-entry-or-migration', label: 'Lateral Entry/Migration' },
            { href: '/admissions/faqs', label: 'FAQs' }
          ]"
                            [href]="link.href"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive(link.href),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive(link.href)
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-b border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ link.label }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </aside>

        <section class="flex-1 shadow-lg p-4 border-2 border-gray-200 h-fit bg-white aarni-font">
            <h2 class="text-2xl font-bold mb-4">Lateral Entry Migration @ARNI</h2>

            <!-- Migration Up to 5th Semester -->
            <div class="flex flex-col md:flex-row items-center py-6">
                <div class="w-full md:w-3/10 flex justify-center">
                    <img src='assets/img/admissions/lateral_entry.png' alt="Migration Policy"
                         class="w-60 h-60 rounded-lg object-cover">
                </div>
                <div class="w-full md:w-7/10">
                    <h2 class="font-semibold text-xl my-2">Lateral Entry into 3rd & 5th Semesters</h2>
                    <p class="text-gray-700 text-justify">
                        Being at the forefront of higher education, we believe in a seamless academic journey. ARNI
                        University always welcomes lateral entry for aspirants who wish to continue their education. We
                        offer lateral entry into the 3rd & 5th semesters to reinitiate the academic journey. Students
                        who wish to get lateral entry into the 3rd or 5th semester directly must have completed the
                        required semester in a relevant program from an accredited university or an educational
                        institution. Candidates must have no active backlogs and a minimum academic standing. It is
                        required to have a current No Objection Certificate (NOC) from the prior school. Seat
                        availability and compliance with ARNI University's academic migration policy are prerequisites
                        for all lateral entry admissions.
                    </p>
                    <button
                        (click)="goTo('form/apply-form')"
                        class="bg-green-400 text-white font-semibold px-6 py-2 rounded-full hover:bg-green-500 transition duration-300 my-4">
                        Apply Now
                    </button>
                </div>
            </div>

            <!-- Study Abroad Opportunity -->
            <div class="flex flex-col md:flex-row items-center py-6">
                <div class="w-full md:w-7/10">
                    <h2 class="font-semibold text-xl my-2">Scholarships for Innovative Thinkers</h2>
                    <p class="text-gray-700 text-justify">
                        At ARNI University, we value creativity, critical thinking, and innovation—especially among
                        students entering through our Lateral Entry programs. To support and encourage forward-thinking
                        individuals, the university offers scholarships to students who demonstrate exceptional
                        problem-solving abilities, unique project work, or community-impact initiatives. These
                        scholarships are awarded based on a combination of academic excellence, originality of ideas,
                        and the potential social or industrial impact of the student's work. Eligible students can
                        benefit from financial assistance in the form of tuition fee waivers, as well as access to
                        mentorship opportunities from expert faculty and support for research and development through
                        university resources. Interested candidates must submit their scholarship application along with
                        detailed documentation of their innovative projects. A review committee evaluates all entries,
                        and shortlisted students may be called for further interaction.
                    </p>
                    <button
                        (click)="goTo('form/apply-form')"
                        class="bg-green-400 text-white font-semibold px-6 py-2 rounded-full hover:bg-green-500 transition duration-300 my-4">
                        Apply Now
                    </button>
                </div>
                <div class="w-full md:w-3/10 flex justify-center">
                    <img src='assets/img/admissions/innovative.png' alt="Innovation Scholarship"
                         class="w-60 h-60 rounded-lg object-cover">
                </div>
            </div>
        </section>
    </div>
</div>
